import React from "react";

/**
 * Shared brand logo used across the app.
 *
 * Design goal: keep the graphic icon compact and put a bold wordmark next to
 * it so the "Terratory Consultants" brand name is clearly readable on every
 * page (the source image has the wordmark baked in but at a size that renders
 * tiny at typical navbar heights).
 *
 * Props:
 *  - variant: "light" (dark-bg) | "dark" (light-bg). Default "dark".
 *  - size:    "sm" | "md" | "lg". Default "md".
 *  - showText: whether to render the wordmark next to the icon. Default true.
 *  - className: extra classes for the outer wrapper.
 */
const LOGO_SRC =
  "https://customer-assets.emergentagent.com/job_poolwise/artifacts/xietdsx0_fulllogo_transparent.png";

const SIZE_MAP = {
  sm: { img: "h-10", title: "text-base", subtitle: "text-[10px]" },
  md: { img: "h-14", title: "text-xl", subtitle: "text-[11px]" },
  lg: { img: "h-20", title: "text-2xl", subtitle: "text-xs" },
};

const Logo = ({
  variant = "dark",
  size = "md",
  showText = true,
  className = "",
}) => {
  const s = SIZE_MAP[size] || SIZE_MAP.md;
  const isLight = variant === "light";

  const titleColor = isLight ? "text-white" : "text-slate-900";
  const subtitleColor = isLight ? "text-white/70" : "text-slate-500";
  const imgFilter = isLight ? "brightness-0 invert" : "";

  return (
    <div
      className={`flex items-center gap-3 ${className}`}
      data-testid="brand-logo"
    >
      <img
        src={LOGO_SRC}
        alt="Terratory Consultants"
        className={`${s.img} w-auto object-contain ${imgFilter}`}
      />
      {showText && (
        <div className="flex flex-col leading-tight">
          <span
            className={`font-heading font-bold tracking-tight ${s.title} ${titleColor}`}
          >
            Terratory Consultants
          </span>
          <span
            className={`uppercase tracking-[0.18em] ${s.subtitle} ${subtitleColor}`}
          >
            Land Pooling Portal
          </span>
        </div>
      )}
    </div>
  );
};

export default Logo;
